module.exports = "<symbol id=\"thebestco-uikit-svg-Minus\" viewBox=\"0 0 10 10\"><rect y=\"4\" width=\"10\" height=\"2.5\" rx=\"1.25\"/></symbol>";